import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

const DbIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 40 40" sx={{ height: '40px', width: '40px', fill: 'transparent', ...sx }} {...props}>
      <rect width="40" height="40" rx="20" fill="#24B07E" fillOpacity="0.1" />
      <path
        d="M20 12V28M20 28L26 22M20 28L14 22"
        stroke="#24B07E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default DbIcon;
